import React from 'react';

import {Card, CardContent, CardHeader, Link, Stack, TextField, Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';

import {useAuth} from '@wheeebo/polaris-api';

const AccountUpdateCard = () => {
  const {account} = useAuth();
  return (
    <Card>
      <CardHeader title="Your profile" />
      <CardContent>
        <Stack gap={1}>
          <TextField disabled fullWidth variant="standard" label="Member ID" value={account?.id} />
          <TextField disabled fullWidth variant="standard" label="Name" value={account?.name} />
          <Link component={RouterLink} to="/settings" align="right">
            <Typography variant="caption">Edit profile</Typography>
          </Link>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default React.memo(AccountUpdateCard);
